import { z } from 'zod';

export const DeviceBaseSchema = z.object({
  id: z.string(),
  level: z.string(),
  frontendId: z.string().optional(),
  fullFrontendId: z.string(),
});

export const DeviceSchema = DeviceBaseSchema.extend({
  lineage: z.array(DeviceBaseSchema),
});

export type Device = z.infer<typeof DeviceSchema>;
export type DeviceBase = z.infer<typeof DeviceBaseSchema>;
